<sura-admin [linkActive] = "linkActive"></sura-admin>
<div class="container pl-0 pr-0">
    <div style="padding: 10px 0px"></div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
        <div class="card-header">
            Administraci&oacute;n de Asambleas
        </div>
        <form  [formGroup]="asambleaForm" autocomplete="off" class="card-body pr-0 pl-0" (submit)="guardarAsamblea()">
            <div class="row">
                <div class="col-12">
                    <input formControlName="estadoCarga" name="estadoCarga" type="hidden">
                </div>
            </div>

            <div class="row">
                <div class="col-6" >
                    <label for="numeroAsamblea" class="col-md-3 col-12 col-form-label">Nro. Asamblea:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <input matInput  name="numeroAsamblea" type="text"
                            formControlName="numeroAsamblea" maxlength="6" required (keypress) = "fnKeyDownNumeric($event)" (keyup) = "fnNumericMobile($event)"  (input)="fnInputMaxLength($event);">
                    </mat-form-field>
                </div>
                <div class="col-2 text-left pl-0 pt-4 pt-md-0 content-btn padding-top-butons-sura">
                    <button  mat-mini-fab color="primary" *ngIf="!disableBtnClone" [disabled]="disableBtnClone" class="ml-2" type="button" (click) ="cloneAsamblea()" matTooltip="Clonar Asamblea"><mat-icon aria-label="icon-button icon">file_copy</mat-icon></button>
                </div>

                <div class="col-4">
                    <label class="col-md-12 col-12 col-form-label">{{estadoCargaLabel}}</label>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-6 col-12 align-self-start">
                    <label for="organizador" class="col-md-3 col-form-label">Organizador:</label>
                    <mat-form-field class=" col-md-9 col-xs-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="organizador" name="organizador" disabled>
                            <mat-option *ngFor="let element of listOrganizadores" [value]="element.idOrganizador">
                                    {{element.organizador}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('organizador')">{{obtenerMensajeError("organizador")}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-12">
                    <label for="tipoParticipante" class="col-md-3 col-form-label">Participantes:</label>
                    <mat-form-field class=" col-md-9 col-xs-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="tipoParticipante" name="tipoParticipante" disabled>
                            <mat-option *ngFor="let element of listTipoParticipante" [value]="element.codigo">
                                    {{element.descripcion}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('tipoParticipante')">{{obtenerMensajeError("tipoParticipante")}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-12">
                    <label for="tipoAsistencia" class="col-md-3 col-form-label">Tipo Asistencia:</label>
                    <mat-form-field class=" col-md-9 col-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="tipoAsistencia" name="tipoAsistencia"  (selectionChange)="selectTipoAsistencia($event.value)"  disabled>
                             <mat-option *ngFor="let element of listTipoAsistente" [value]="element.codigo">
                                        {{element.descripcion}}
                             </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('tipoAsistencia')">{{obtenerMensajeError("tipoAsistencia")}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-12">
                    <label for="estado" class="col-md-3 col-form-label">Estado:</label>
                    <mat-form-field class="col-md-9" appearance="outline">
                        <input matInput  name="estado" type="text" formControlName="estado" disabled>
                        <mat-error *ngIf="hasError('estado')">{{obtenerMensajeError("estado")}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">

                <div class="col-md-6 col-12">
                    <label for="tipoEnvio" class="col-md-3 col-form-label">Tipo de quórum:</label>
                    <mat-form-field class=" col-md-9 col-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="tipoQuorum" name="tipoQuorum" disabled>
                            <mat-option *ngFor="let element of listTipoQuorum" [value]="element.codigo">
                                {{element.descripcion}}
                            </mat-option>
                            
                        </mat-select>
                        <mat-error *ngIf="hasError('tipoQuorum')">{{obtenerMensajeError("tipoQuorum")}}</mat-error>
                    </mat-form-field>
                </div>





                <div class="col-md-6 col-12">
                    <label for="tipoEnvio" class="col-md-3 col-form-label">Tipo de Envío:</label>
                    <mat-form-field class=" col-md-9 col-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="tipoEnvio" name="tipoEnvio" disabled>
                            <mat-option *ngFor="let element of listTipoEnvio" [value]="element.codigo">
                                {{element.descripcion}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('tipoEnvio')">{{obtenerMensajeError("tipoEnvio")}}</mat-error>
                    </mat-form-field>
                </div>
                
            </div>
            <div class="row">

                <div class="col-md-6 col-12">
                    <label for="tiempoAsignado" class="col-md-3 col-form-label">Tiempo:</label>
                    <mat-form-field class="col-md-4 col-5 " appearance="outline">
                        <mat-label>MM</mat-label>
                        <input matInput placeholder="MM" formControlName="tiempoAsignado" name="tiempoAsignado" type="number" disabled class="text-right">
                        <mat-icon matSuffix class="ml-2 ml-md-1">timer</mat-icon>
                        <mat-hint>Minutos</mat-hint>
                        <mat-error *ngIf="hasError('tiempoAsignado')">{{obtenerMensajeError("tiempoAsignado")}}</mat-error>
                    </mat-form-field>
                </div>





                <div class="col-md-6 col-12">
                    <label for="fechaInicio" class="col-md-3 col-form-label">Fecha Inicio:</label>
                    <div class="col-md-9" style="display: inline-block">
                        <mat-form-field  appearance="outline" style="width:38%">
                            <mat-label>dd/mm/yyyy</mat-label>
                            <input matInput formControlName="fechaInicio" name="fechaInicio" [min]="minDateInicio" [max]="maxDateInicio" [matDatepicker]="pickerFechaInicio"
                                placeholder="dd/mm/yyyy" readonly (focus)="pickerFechaInicio.open()" (dateChange)="changeFechaInicio($event)">
                        <mat-datepicker-toggle matSuffix [for]="pickerFechaInicio"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFechaInicio></mat-datepicker>
                            <mat-error *ngIf="hasError('fechaInicio')">{{obtenerMensajeError("fechaInicio")}}</mat-error>
                        </mat-form-field>
                        <mat-form-field  appearance="outline" class="text-right" style="width:29%;margin-left: 2%">
                            <mat-label>HH</mat-label>
                            <input matInput formControlName="fechaInicioHH" name="fechaInicioHH" placeholder="HH" type="number" min="0" max="23" (change)="changeFechaInicioHH($event)">
                            <mat-error *ngIf="hasError('fechaInicioHH')">{{obtenerMensajeError("fechaInicioHH")}}</mat-error>
                        </mat-form-field>
                        <mat-form-field  appearance="outline" class="text-right" style="width:29%;margin-left: 2%">
                            <mat-label>MM</mat-label>
                            <input matInput formControlName="fechaInicioMM" name="fechaInicioMM" placeholder="MM" type="number" min="0" max="59" (change)="changeFechaInicioMM($event)">
                            <mat-error *ngIf="hasError('fechaInicioMM')">{{obtenerMensajeError("fechaInicioMM")}}</mat-error>
                    </mat-form-field>
                </div>
                </div>
                
            </div>


            <div class="row">
                
                <div class="col-md-6 col-12">
                    <label for="fechaFin" class="col-md-3 col-form-label">Fecha Fin:</label>
                    <div class="col-md-9" style="display: inline-block">
                        <mat-form-field  appearance="outline" style="width:38%">
                            <mat-label>dd/mm/yyyy</mat-label>
                            <input matInput formControlName="fechaFin" name="fechaFin" [min]="minDateFin" [max]="maxDateFin" [matDatepicker]="pickerFechaFin"
                            placeholder="dd/mm/yyyy" readonly (focus)="pickerFechaFin.open()" (dateChange)="changeFechaFin($event)">
                        <mat-datepicker-toggle matSuffix [for]="pickerFechaFin"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFechaFin></mat-datepicker>
                            <mat-error *ngIf="hasError('fechaFin')">{{obtenerMensajeError("fechaFin")}}</mat-error>
                    </mat-form-field>
                        <mat-form-field  appearance="outline" class="text-right" style="width:29%;margin-left: 2%">
                                <mat-label>HH</mat-label>
                            <input matInput formControlName="fechaFinHH" name="fechaFinHH" placeholder="HH" type="number" min="0" max="23" (change)="changeFechaFinHH($event)">
                            <mat-error *ngIf="hasError('fechaFinHH')">{{obtenerMensajeError("fechaFinHH")}}</mat-error>
                        </mat-form-field>
                        <mat-form-field  appearance="outline" class="text-right" style="width:29%;margin-left: 2%">
                            <mat-label>MM</mat-label>
                            <input matInput formControlName="fechaFinMM" name="fechaFinMM" placeholder="MM" type="number" min="0" max="59" (change)="changeFechaFinMM($event)">
                            <mat-error *ngIf="hasError('fechaFinMM')">{{obtenerMensajeError("fechaFinMM")}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-md-6 col-12" *ngIf="mostrarFechaAnticipada">
                    <label for="fechaAnticipada" class="col-md-3 col-form-label">Fecha Anticipada:</label>
                    <div class="col-md-9" style="display: inline-block">
                        <mat-form-field  appearance="outline" style="width:38%">
                            <mat-label>dd/mm/yyyy</mat-label>
                            <input matInput formControlName="fechaAnticipada" name="fechaAnticipada" [min]="minDateAnticipada" [max]="maxDateAnticipada" [matDatepicker]="pickerFechaAnticipada"
                            placeholder="dd/mm/yyyy" readonly (focus)="pickerFechaAnticipada.open()" (dateChange)="changeFechaAnticipada($event)">
                        <mat-datepicker-toggle matSuffix [for]="pickerFechaAnticipada"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFechaAnticipada></mat-datepicker>
                            <mat-error *ngIf="hasError('fechaAnticipada')">{{obtenerMensajeError("fechaAnticipada")}}</mat-error>
                    </mat-form-field>
                        <mat-form-field  appearance="outline" class="text-right" style="width:29%;margin-left: 2%">
                                <mat-label>HH</mat-label>
                            <input matInput formControlName="fechaAnticipadaHH" name="fechaAnticipadaHH" placeholder="HH" type="number" min="0" max="23" (change)="changeFechaAnticipadaHH($event)">
                            <mat-error *ngIf="hasError('fechaAnticipadaHH')">{{obtenerMensajeError("fechaAnticipadaHH")}}</mat-error>
                        </mat-form-field>
                        <mat-form-field  appearance="outline" class="text-right" style="width:29%;margin-left: 2%">
                            <mat-label>MM</mat-label>
                            <input matInput formControlName="fechaAnticipadaMM" name="fechaAnticipadaMM" placeholder="MM" type="number" min="0" max="59" (change)="changeFechaAnticipadaMM($event)">
                            <mat-error *ngIf="hasError('fechaAnticipadaMM')">{{obtenerMensajeError("fechaAnticipadaMM")}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>

              
            </div>






            <div class="row">
                
                <div class="col-md-6 col-12" *ngIf="verExcelUpload">
                    <div class="col-md-8" style="display: inline-block">  
                        <input type="file" (change)="onFileSelected($event)" accept=".xls,.xlsx" style="display: none" #fileInput/>
                        <button mat-raised-button color="primary" class="btn-block" type="button" (click)="fileInput.click()">Seleccionar Excel</button>
                        <span *ngIf="fileName">{{ fileName }}</span>
                                         
                       
                    </div>
                </div>



                <div class="col-md-6 col-12">
                    <label for="tipoAsamblea" class="col-md-3 col-form-label">Tipo de Asamblea:</label>
                    <mat-form-field class=" col-md-9 col-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="tipoAsamblea" name="tipoAsamblea" >
                             <mat-option *ngFor="let element of listTipoAsamblea" [value]="element.codigo">
                                        {{element.descripcion}}
                             </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('tipoAsistencia')">{{obtenerMensajeError("tipoAsistencia")}}</mat-error>
                    </mat-form-field>
                </div>

              
            </div>






            <mat-divider></mat-divider>
            <div class="content-pregunta p-2">
                <mat-accordion formArrayName="listaPreguntas">
                    <mat-expansion-panel *ngFor="let pregunta of getListPreguntaFormArray().controls; let i = index;"
                        [expanded]="step === i" (opened)="setStep(i)" >
                        <mat-expansion-panel-header>
                            <mat-panel-title style="min-width:75px; max-width: 85px;" class="pt-2">
                                <label class="col-form-label">Votación {{i + 1}}:</label>
                            </mat-panel-title>
                            <mat-panel-description class="pt-2">{{formatearResumenPregunta(pregunta,i)}}</mat-panel-description>
                            <button  matTooltip="Eliminar votaci&oacute;n" mat-icon-button type="button" class="mr-2 ml-3" color="warn" [disabled]="getListPreguntaFormArray().controls.length <= 1 || disableBtnElimnarPregunta" (click)="eliminarPregunta(i)">
                                <mat-icon>remove_circle</mat-icon>
                            </button>
                        </mat-expansion-panel-header>
                        <div [formGroupName]="i">
                <div class="row">
                                        <mat-form-field class="col-md-8 col-8" appearance="outline" >
                                            <mat-label>Pregunta</mat-label>
                                            <textarea  matInput  name="pregunta" type="text"  placeholder="Pregunta" formControlName="pregunta"
                                                 maxlength="500" (input)="fnInputMaxLength($event);"></textarea>
                                            <mat-error *ngIf="hasErrorPreguntas('pregunta',i)">{{obtenerMensajeErrorPreguntas("pregunta",i)}}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="col-md-2 col-2" appearance="outline" >
                        <mat-label>Tipo pregunta</mat-label>
                        <mat-select placeholder="Tipo Pregunta" [(ngModel)]="selectedTipoPregunta[i]" (selectionChange)="onSelectTipoPregunta(i)" name="tipoPregunta" formControlName="tipoPregunta">
                            <mat-option *ngFor="let element of listTipoPreguntaOpcion ; let first = first" [value]="element.id" [selected]="first">
                                    {{element.descripcion}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasErrorPreguntas('tipoPregunta',i)">{{obtenerMensajeErrorPreguntas("tipoPregunta",i)}}</mat-error>
                    </mat-form-field>

                    <mat-form-field  appearance="outline" class="col-md-2 col-2" *ngIf="selectedTipoPregunta[i] === 2">
                        <mat-label>Nro opc.</mat-label>
                        <input matInput class="text-right" formControlName="numOpc" name="numOpc" placeholder="Núm. Opc." type="number" min="2" max="10">
                        <mat-error *ngIf="hasErrorPreguntas('numOpc',i)">{{obtenerMensajeErrorPreguntas("numOpc",i)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                                        <mat-form-field class=" col-md-11 col-10" appearance="outline">
                                                <mat-label>Opciones</mat-label>
                                            <mat-select placeholder="Seleccione" name="plantillaOpcion" formControlName="opcion" (selectionChange)="changeOpcion($event, i)">
                            <mat-option *ngFor="let element of listPlantillaOpcion" [value]="element.id">
                                    {{element.descripcion}}
                            </mat-option>
                        </mat-select>
                                            <mat-error *ngIf="hasErrorPreguntas('opcion',i)">{{obtenerMensajeErrorPreguntas("opcion",i)}}</mat-error>
                    </mat-form-field>
                                        <div class="col-md-1 col-2 text-left pl-0">
                                            <button matTooltip="Agregar nuevas opciones"  mat-mini-fab color="primary" class="ml-2" type="button" [disabled]="disableBtnAgregarPlantilla" (click) ="mostrarModalAgregarPlantillaOpciones()">
                                                <mat-icon aria-label="icon-button icon">add</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <div class="row pl-2 pr-2 mb-2">
                <div class="col-md-3 col-12">
                    <button mat-raised-button color="primary" class="btn-block" type="button" [disabled] = "!permitirAgregarPregunta()" (click)="agregarPregunta()">
                        <mat-icon aria-label="icon-button icon">add_box</mat-icon> Agregar Votaci&oacute;n
                    </button>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div mat-dialog-actions class="d-flex justify-content-end mt-2 pr-2">
                <button mat-raised-button color="primary" routerLink="/mntAsamblea"><mat-icon>arrow_back</mat-icon> &nbsp;&nbsp;Regresar</button>
                 &nbsp;&nbsp;
                <button mat-raised-button type="submit" cdkFocusInitial color="primary" >
                    <mat-icon>save</mat-icon>
                Guardar</button>
            </div>
        </form>
    </div>
</div>
